<template>
  <div
    :id="id"
    class="modal-add modal-variable"
  >
    <!-- Title -->
    <div class="modal-title">
      <h4 class="title">{{ dataVariable ? 'Edit' : 'Add' }} Variable</h4>
    </div>

    <div class="wrap-content-modal">
      <b-form-group
        :class="{'error-input' : $v.variable.name.$error}"
        class="mb-1"
      >
        <label> Name </label>
        <j-input
          v-model="variable.name"
          :error-required="false"
          placeholder="Input variable name"
        />
      </b-form-group>
      <b-form-group
        :class="{'error-input' : $v.variable.type.$error}"
        class="mb-1"
      >
        <label> Type </label>
        <j-single-select
          v-model="variable.type"
          :options="typeOptions"
          :error-required="false"
          placeholder="Select variable type"
          label="name"
        />
      </b-form-group>
      <b-form-group
        :class="{'error-input' : $v.variable.value.$error}"
        class="mb-1"
      >
        <label> Value </label>
        <j-input
          v-model="variable.value"
          :error-required="false"
          placeholder="Input variable value"
        />
      </b-form-group>
    </div>

    <!-- Button -->
    <div class="d-flex justify-content-end mt-4">
      <button
        class="button-border mr-2"
        @click="$emit('close-modal')"
      >
        Close
      </button>
      <button
        class="button-blue"
      >
        {{ dataVariable ? 'Update' : 'Apply' }}
      </button>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    dataVariable: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      variable: {
        name: '',
        type: null,
        value: '',
      },
      typeOptions: [
        { id: 'text', name: 'Text' },
      ],
    };
  },

  created() {
    if (this.dataVariable) {
      this.variable.name = this.dataVariable.name;
      this.variable.type = this.dataVariable.type;
      this.variable.value = this.dataVariable.value;
    }
  },

  validations() {
    return {
      variable: {
        name: { required },
        type: { required },
        value: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/app-tabs/partials/modal/modalVariable.vue